import { useNavigate } from 'react-router-dom'
import { ArrowRight, Calculator, BookOpen, FlaskConical, Globe, Languages, Code } from 'lucide-react'

const iconMap = {
  matematica: Calculator,
  portugues: BookOpen,
  ciencias: FlaskConical,
  humanas: Globe,
  idiomas: Languages,
  tecnologia: Code
}

const colorMap = {
  matematica: 'bg-blue-50 text-blue-600 border-blue-100',
  portugues: 'bg-red-50 text-red-600 border-red-100',
  ciencias: 'bg-emerald-50 text-emerald-600 border-emerald-100',
  humanas: 'bg-amber-50 text-amber-600 border-amber-100',
  idiomas: 'bg-violet-50 text-violet-600 border-violet-100',
  tecnologia: 'bg-cyan-50 text-cyan-600 border-cyan-100'
}

function MateriaCard({ materia }) {
  const navigate = useNavigate()
  const Icon = iconMap[materia.slug] || BookOpen
  const colorClass = colorMap[materia.slug] || 'bg-gray-50 text-gray-600 border-gray-100'

  return (
    <button
      onClick={() => navigate(`/materia/${materia.id}`)}
      className={`group flex min-h-36 flex-col items-start gap-2 rounded-xl border p-4 text-left transition-all hover:-translate-y-0.5 hover:shadow-md active:scale-[0.98] ${colorClass}`}
    >
      <Icon size={28} strokeWidth={1.5} />
      <span className="text-sm font-medium leading-tight">{materia.nome}</span>
      <span className="mt-auto inline-flex items-center gap-1 text-[11px] font-medium opacity-70 group-hover:opacity-100">
        Pesquisar aulas <ArrowRight size={12} />
      </span>
    </button>
  )
}

export default MateriaCard
